<script lang="ts">
  export let value = 0;
  export let containerElement: HTMLElement | null = null;
</script>

<div class="container" class:double={value >= 10} bind:this={containerElement}>
  <p>{value}</p>
</div>

<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: var(--rekki-neutral-04);
    padding: 1px 3px 0px 3px;
    height: 14px;
    width: 14px;

    font-size: 9px;
    letter-spacing: -0.1%;
    font-weight: 500;
    font-family: "DiatypeRekkiMedium";
    color: var(--rekki-light);
  }

  .double {
    min-width: 18px;
  }
</style>
